import { withInstall } from '@ll-plus/utils'

import ModalOverlay from './src/modal-overlay.vue'

export const LlModalOverlay = withInstall(ModalOverlay)
export default LlModalOverlay
export * from './src/modal-overlay'

declare module 'vue' {
  export interface GlobalComponents {
    LlModalOverlay: typeof ModalOverlay
  }
}
